import "../styles/MisCuestionarios.css";
import React, { useContext } from "react";
import { Container, Stack, Box } from "@mui/material";
import { CuestionarioHistoricos } from "../components/commons/CuestionarioHistoricos";
import ContinuarCuestionario from "../components/ContinuarCuestionario";
import { MisCuestionariosContext } from "../context/MisCuestionariosContext";
import { useTranslation } from "react-i18next";
import { GeneralContext } from "../context/GeneralContext";
import { useSecurity } from "../hooks/useSecurity"
import { LineChart } from "../components/LineChart";
import { Titulo } from "../components/commons/Titulo";
import { ContinuarCuestionarioSkeleton } from "../components/commons/ContinuarCuestionarioSkeleton";

export function MisCuestionarios() {
  const { cuestionarios, loadingCuestionarioActual } = useContext(MisCuestionariosContext);
  const { t } = useTranslation();
  const { } = useContext(GeneralContext);
  const { } = useContext(MisCuestionariosContext);
  useSecurity()

  return (
    <>
      <Container>
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="center"
          spacing={2}
        >
          <Box sx={{ width: "100%" }}>
            <Box className="textCard">
              {loadingCuestionarioActual ? (
                <ContinuarCuestionarioSkeleton />
              ) : (
                <ContinuarCuestionario />
              )}
            </Box>
            <Box>
              <Titulo titulo={t("misCuestionarios.historico")} size={"1.5em"} />
            </Box>
            {cuestionarios?.length > 0 && (
              <Box sx={{ height: "400px" }}>
                <LineChart cuestionarios={cuestionarios} />
              </Box>
            )}
            <Box sx={{ marginTop: "30px" }} >
              <CuestionarioHistoricos cuestionarios={cuestionarios} />
            </Box>
          </Box>
        </Stack>
      </Container>
    </>
  );
}
